var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "support",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.817,
    height: 51.751,
    viewBox: "0 0 51.817 51.751",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39706",
    "data-name": "Group 39706",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101676",
    "data-name": "Path 101676",
    d: "M-7815.838-3120.979a4.968,4.968,0,0,1-4.324-5.514,21.9,21.9,0,0,0,.487-8.811c-.108,0-.973-7.622,8.811-5.027,0-.216,13.3,4,12.541,15.46-.054-.054-1.784,10.649-12.541,5.405-.108-.054-4.208-1.268-4.66-1.414A3.131,3.131,0,1,0-7815.838-3120.979Z",
    transform: "translate(7820.178 3152.203)",
    fill: "#e7f4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "technical-support",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41256",
    "data-name": "Group 41256",
    transform: "translate(8.161 13.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41254",
    "data-name": "Group 41254",
    transform: "translate(19.58 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122897",
    "data-name": "Path 122897",
    d: "M274.106,135.127v6.446h2.65a1.738,1.738,0,0,0,1.738-1.738v-2.97a1.738,1.738,0,0,0-1.738-1.738h-2.65Z",
    transform: "translate(-274.106 -135.127)",
    fill: "#9bc4f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41255",
    "data-name": "Group 41255",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122898",
    "data-name": "Path 122898",
    d: "M85.028,135.127v6.446h-2.65a1.738,1.738,0,0,1-1.738-1.738v-2.97a1.738,1.738,0,0,1,1.738-1.738h2.65Z",
    transform: "translate(-80.64 -135.127)",
    fill: "#9bc4f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41273",
    "data-name": "Group 41273",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41272",
    "data-name": "Group 41272",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41267",
    "data-name": "Group 41267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41263",
    "data-name": "Group 41263",
    transform: "translate(34.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122899",
    "data-name": "Path 122899",
    d: "M346.083.322h-6.7A2.274,2.274,0,0,0,337.111,2.6V9.174a2.274,2.274,0,0,0,2.274,2.274c.742,0,.852.139,1.09.365h4.2c.244-.231.382-.365,1.132-.365h.325a2.274,2.274,0,0,0,2.226-2.273V2.6A2.274,2.274,0,0,0,346.083.322Z",
    transform: "translate(-337.111 -0.322)",
    fill: "#feb068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122900",
    "data-name": "Path 122900",
    d: "M429.037.322h-6.812A2.274,2.274,0,0,1,424.5,2.6V9.174a2.274,2.274,0,0,1-2.226,2.273h6.764a2.274,2.274,0,0,0,2.274-2.274V2.6A2.274,2.274,0,0,0,429.037.322Z",
    transform: "translate(-413.611 -0.322)",
    fill: "#eb7f58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41262",
    "data-name": "Group 41262",
    transform: "translate(2.719 3.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41259",
    "data-name": "Group 41259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41257",
    "data-name": "Group 41257",
    transform: "translate(3.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122901",
    "data-name": "Path 122901",
    d: "M409.868,32.215h-6.823a.782.782,0,1,1,0-1.564h6.823a.782.782,0,1,1,0,1.564Z",
    transform: "translate(-402.263 -30.651)",
    fill: "#f2f9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41258",
    "data-name": "Group 41258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122902",
    "data-name": "Path 122902",
    d: "M365.593,32.215h-.832a.782.782,0,0,1,0-1.564h.832a.782.782,0,1,1,0,1.564Z",
    transform: "translate(-363.98 -30.651)",
    fill: "#f2f9ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41261",
    "data-name": "Group 41261",
    transform: "translate(0 3.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41260",
    "data-name": "Group 41260",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122903",
    "data-name": "Path 122903",
    d: "M375.459,68.51h-10.7a.782.782,0,0,1,0-1.564h10.7a.782.782,0,0,1,0,1.564Z",
    transform: "translate(-363.98 -66.946)",
    fill: "#f2f9ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41266",
    "data-name": "Group 41266",
    transform: "translate(0 23.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41265",
    "data-name": "Group 41265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41264",
    "data-name": "Group 41264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122904",
    "data-name": "Path 122904",
    d: "M150.2,239.3a2.277,2.277,0,0,1-1.847-2.236v-6.254h-8.705v6.254A2.282,2.282,0,0,1,137.8,239.3l2.151,2.886h8.1A28.379,28.379,0,0,0,150.2,239.3Z",
    transform: "translate(-123.853 -230.813)",
    fill: "#ffddce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122905",
    "data-name": "Path 122905",
    d: "M45.221,335.743v-3.716a13.448,13.448,0,0,0-10.906-13.206c-.62-.119-17.226,0-17.226,0A13.448,13.448,0,0,0,6.182,332.027v3.716Z",
    transform: "translate(-5.556 -309.867)",
    fill: "#ffa265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122906",
    "data-name": "Path 122906",
    d: "M58.469,312.374H36.176a2.4,2.4,0,0,0-2.4,2.53l.842,15.521h25.4l.842-15.521A2.4,2.4,0,0,0,58.469,312.374Z",
    transform: "translate(-30.357 -304.12)",
    fill: "#eaf2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122907",
    "data-name": "Path 122907",
    d: "M280.122,312.374H273.31a2.4,2.4,0,0,1,2.4,2.53l-.842,15.521h6.812l.842-15.521A2.4,2.4,0,0,0,280.122,312.374Z",
    transform: "translate(-245.65 -304.12)",
    fill: "#dbe8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122908",
    "data-name": "Path 122908",
    d: "M33.7,480.133V478.85l-.274-.4H1.681a1.681,1.681,0,1,0,0,3.363H32.023a1.681,1.681,0,0,0,1.68-1.681Z",
    transform: "translate(0 -453.39)",
    fill: "#9bc4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122909",
    "data-name": "Path 122909",
    d: "M320.564,478.451h-5.179v1.681a1.681,1.681,0,0,1-1.681,1.681h6.861a1.681,1.681,0,0,0,0-3.363Z",
    transform: "translate(-281.955 -453.389)",
    fill: "#7fb2f9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_122910",
    "data-name": "Path 122910",
    d: "M158.8,379.6a5.572,5.572,0,0,1,1.438-3.727l.021-.023a4.77,4.77,0,0,0-1.2-7.326.41.41,0,0,0-.614.355v3.548a1.077,1.077,0,0,1-1.077,1.077h-1.324a1.077,1.077,0,0,1-1.077-1.077v-3.548a.41.41,0,0,0-.614-.355,4.77,4.77,0,0,0-1.2,7.326l.021.023A5.572,5.572,0,0,1,154.6,379.6Z",
    transform: "translate(-136.552 -354.541)",
    fill: "#bcd6f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41271",
    "data-name": "Group 41271",
    transform: "translate(9.583 2.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41270",
    "data-name": "Group 41270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41269",
    "data-name": "Group 41269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41268",
    "data-name": "Group 41268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122911",
    "data-name": "Path 122911",
    d: "M124.356,65.208a8.263,8.263,0,0,0,2.728-6.082l-.028-11.207a8.416,8.416,0,0,0-.942-3.879,8.967,8.967,0,0,0-3.062-.562,8.447,8.447,0,0,0-8.5,8.418l.007,1.653.025,5.549a8.076,8.076,0,0,0,2.716,5.923,9.044,9.044,0,0,0,3.95,2.026A9.434,9.434,0,0,0,124.356,65.208Z",
    transform: "translate(-112.544 -42.043)",
    fill: "#ffddce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122912",
    "data-name": "Path 122912",
    d: "M186.368,55.564a8.291,8.291,0,0,0-5.92-7.924,8.193,8.193,0,0,1,1.131,4.171l.028,10.955a8.077,8.077,0,0,1-2.666,5.946,9.129,9.129,0,0,1-3.471,1.939,8.576,8.576,0,0,0,8.26-1.939,8.078,8.078,0,0,0,2.666-5.946Z",
    transform: "translate(-167.294 -45.784)",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122913",
    "data-name": "Path 122913",
    d: "M104.955,36.3h.592a7.625,7.625,0,0,0,2.363-.392A4.327,4.327,0,0,1,109.2,35.7v-.522a8.384,8.384,0,0,0-1.157-4.267h0a8.352,8.352,0,0,0-1.021-1.379l-.683-.231h-4.979a6.673,6.673,0,0,0-6.673,6.673v4.41a1.522,1.522,0,0,0,1.022,1.438l1.644.572a.883.883,0,0,0,1.174-.835l0-3.11a2.722,2.722,0,0,1,2.694-2.75h.033a4.327,4.327,0,0,1,1.342.208,7.624,7.624,0,0,0,2.363.392Z",
    transform: "translate(-94.689 -29.301)",
    fill: "#756e78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122914",
    "data-name": "Path 122914",
    d: "M216.691,32.782H216.6a.879.879,0,0,1-.879-.879,2.6,2.6,0,0,0-2.6-2.6h-3.3a8.132,8.132,0,0,1,2.633,6.027v.379c.092-.006.184-.009.277-.008h.033a2.722,2.722,0,0,1,2.694,2.75l0,3.11a.883.883,0,0,0,1.174.835l1.643-.572a1.522,1.522,0,0,0,1.022-1.438v-5A2.6,2.6,0,0,0,216.691,32.782Z",
    transform: "translate(-198.168 -29.301)",
    fill: "#665e66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122915",
    "data-name": "Path 122915",
    d: "M238.011,183.377v1.14a1.613,1.613,0,0,1-1.611,1.611h-4.814a.782.782,0,1,0,0,1.564H236.4a3.178,3.178,0,0,0,3.175-3.175v-2.87A1.738,1.738,0,0,1,238.011,183.377Z",
    transform: "translate(-217.029 -166.229)",
    fill: "#dbe8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122916",
    "data-name": "Path 122916",
    d: "M227.9,221.7h-1.962a1.356,1.356,0,0,1,0-2.711H227.9a1.356,1.356,0,1,1,0,2.711Z",
    transform: "translate(-211.432 -199.79)",
    fill: "#fe9c63"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41274",
    "data-name": "Group 41274",
    transform: "translate(36.391 11.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122917",
    "data-name": "Path 122917",
    d: "M365.952,110.251h-6.371a1.328,1.328,0,0,1,1.328,1.328v4.068a.509.509,0,0,0,.946.262l3.006-5.012a1.328,1.328,0,0,1,1.092-.644h0Z",
    transform: "translate(-359.581 -110.251)",
    fill: "#eb7f58"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg4);
export default __webpack_public_path__ + "static/media/svg4.3970a8ed941b2b3176598fc4498f921d.svg";
export { ForwardRef as ReactComponent };